import { Flex, FormControl, FormLabel, Grid, Text } from "@chakra-ui/react";
import { useFormikContext } from "formik";
import { InputWithValidationControl } from "src/components/Inputs/InputWithValidationControl";
import { PhoneInput } from "src/components/Inputs/PhoneInput";
import useRequiredHasuraRoles from "src/hooks/useRequiredHasuraRoles";
import { HasuraRole } from "src/types/hasuraRole";
import { PASSWORD_MANAGER_IGNORE } from "src/types/passwordManager";
import { AddressForm } from "../../components/Forms/AddressForm";
import { NameForm } from "../../components/Forms/NameForm";
import { ParentProfileFormType } from "../schemas";

export const ParentDetailsForm: React.FC<{
  isDisabled?: boolean;
  // Opt in to required-field asterisks (used on the create page). Off by default.
  requiredIndicators?: boolean;
  // Opt in to the "at least one contact method" rule's inline message. Off by
  // default; the create page turns it on.
  requireContact?: boolean;
}> = ({
  isDisabled = false,
  requiredIndicators = false,
  requireContact = false,
}) => {
  const isAllowedToEditRefId = useRequiredHasuraRoles([
    HasuraRole.ADMIN,
    HasuraRole.ORG_ADMIN,
  ]);

  const { values, touched, submitCount } =
    useFormikContext<ParentProfileFormType>();
  const showContactRequired =
    requireContact &&
    !values.email_address?.trim() &&
    !values.phone_number?.trim() &&
    (submitCount > 0 || !!touched.email_address || !!touched.phone_number);

  return (
    <Flex direction="column" gap={4}>
      <NameForm
        hide={["birth_date"]}
        firstName={{ label: "First name" }}
        middleName={{ label: "Middle name" }}
        lastName={{ label: "Last name" }}
        isDisabled={isDisabled}
        showRequiredIndicator={requiredIndicators}
      />
      <Grid gridTemplateColumns="repeat(auto-fit, minmax(15rem, 1fr))" gap={3}>
        <InputWithValidationControl
          isRequired={false}
          name="email_address"
          id="email_address"
          label="Email address (Optional)"
          inputProps={{
            placeholder: "E.g: dandoe@email.com",
            ...PASSWORD_MANAGER_IGNORE,
          }}
          isDisabled={isDisabled}
        />
        <FormControl>
          <FormLabel>Phone number (Optional)</FormLabel>
          <PhoneInput
            id="phone_number"
            name="phone_number"
            isRequired={false}
            inputProps={{
              placeholder: "E.g: +1 (555) 555-0100",
              ...PASSWORD_MANAGER_IGNORE,
            }}
          />
        </FormControl>
      </Grid>
      {showContactRequired && (
        <Text color="red.500" fontSize="sm" marginTop={-2}>
          An email or a phone number is required
        </Text>
      )}
      <InputWithValidationControl
        isRequired={false}
        name="reference_id"
        id="reference_id"
        label="Reference ID (Optional)"
        inputProps={{
          placeholder: "E.g.: 12345678",
          ...PASSWORD_MANAGER_IGNORE,
        }}
        isDisabled={!isAllowedToEditRefId || isDisabled}
      />
      <AddressForm isDisabled={isDisabled} isRequired={requiredIndicators} />
    </Flex>
  );
};
